const dict = {
  es: {
    app_name: "Diálogo Sereno",
    tagline: "Practica Comunicación No Violenta",
    hero_title: "Habla desde el corazón, escucha sin juzgar",
    hero_sub: "Aprende los 4 pasos de la CNV y practica con familia, pareja, trabajo, relaciones y escuela — con un coach de IA.",
    get_started: "Comenzar",
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    language: "Idioma",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    dashboard: "Inicio",
    study: "Estudiar",
    exercises: "Ejercicios",
    practice: "Chat Bonobo 🐒",
    journal: "Diario",
    library: "Biblioteca",
    welcome: "Bienvenido",
    steps_completed: "Pasos completados",
    exercises_solved: "Ejercicios resueltos",
    journal_entries: "Entradas del diario",
    accuracy: "Precisión",
    next_step: "Siguiente paso",
    continue_learning: "Continuar aprendiendo",
    start_learning: "Empieza a aprender",
    the_four_steps: "Los 4 pasos de la CNV",
    key_points: "Puntos clave",
    mark_complete: "Marcar como completado",
    completed: "Completado",
    correct: "¡Correcto!",
    incorrect: "Inténtalo de nuevo",
    show_explanation: "Ver explicación",
    next_exercise: "Siguiente",
    prev_exercise: "Anterior",
    choose_context: "Elige un contexto",
    scenario: "Escenario",
    optional_scenario: "Escenario (opcional)",
    start_practice: "Comenzar práctica",
    send: "Enviar",
    type_message: "Escribe tu mensaje…",
    coach_thinking: "El coach está pensando…",
    new_entry: "Nueva entrada",
    observation: "Observación",
    feeling: "Sentimiento",
    need: "Necesidad",
    request: "Petición",
    notes: "Notas",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    no_entries: "Aún no tienes entradas. Escribe la primera.",
    context: "Contexto",
    feelings_met: "Sentimientos (necesidades cubiertas)",
    feelings_unmet: "Sentimientos (necesidades no cubiertas)",
    needs: "Necesidades universales",
    library_intro: "Amplía tu vocabulario emocional y de necesidades.",
    saved: "Guardado",
    deleted: "Eliminado",
    error: "Ocurrió un error",
    popup_blocked: "Activa las ventanas emergentes para abrir Stripe Checkout.",
    lesson: "Lección",
    practice_intro: "Elige un contexto y practica una conversación real con tu coach.",
    streak: "Racha",
    days: "días",
    day: "día",
    daily_prompt: "Práctica del día",
    empathy: "Empatía",
    all_steps: "Todos",
    refine_ai: "Refinar con IA",
    ai_rewriting: "Reescribiendo con IA…",
    ai_suggestion: "Sugerencia CNV",
    use_suggestion: "Usar sugerencia",
    export_pdf: "Exportar PDF",
    reminders: "Recordatorios diarios",
    enable_notifications: "Activar notificaciones",
    notifications_enabled: "Notificaciones activadas",
    notifications_denied: "Notificaciones bloqueadas",
    practiced_today: "¡Practicaste hoy! 🌱",
    streak_fire: "🔥 ¡En racha!",
    streak_milestone_3: "¡3 días seguidos! Sigue así.",
    streak_milestone_7: "🔥 ¡Una semana! Impresionante.",
    streak_milestone_14: "🔥🔥 ¡Dos semanas! Estás construyendo un hábito.",
    streak_milestone_30: "🔥🔥🔥 ¡Un mes entero! La CNV es parte de ti.",
    streak_milestone_100: "🌟 ¡100 días! Eres un maestro de la CNV.",
    reminder_hour: "Hora del recordatorio",
    reminder_off: "Sin recordatorio",
    send_test_push: "Enviar prueba",
    push_sent: "Notificación enviada",
    answers: "respuestas",
    month: "mes",
    most_popular: "Más popular",
    unlimited: "Ilimitado",
    choose_plan: "Elige tu plan",
    points_to_basic: "Puntos para plan Básico",
    plan: "Plan",
    free_plan: "Plan Free",
    premium_plan: "Premium",
    upgrade: "Mejorar a Premium",
    upgrade_now: "Mejorar ahora",
    current_plan: "Tu plan",
    days_left: "días restantes",
    points: "Puntos",
    redeem_points: "Canjear 500 puntos",
    points_to_premium: "Puntos para Premium",
    or_pay: "O paga con tarjeta",
    pay_499: "$4.99 · 30 días",
    premium_features: "Beneficios Premium",
    premium_feat_1: "Ejercicios avanzados por contexto (25+)",
    premium_feat_2: "Coach IA sin límite (free: 5/día)",
    premium_feat_3: "Refinar diario con IA sin límite (free: 3/día)",
    premium_feat_4: "Sin paywalls ni interrupciones",
    limit_reached: "Límite diario alcanzado",
    limit_reached_ai: "Has usado tus 5 mensajes al coach IA de hoy",
    limit_reached_rewrite: "Has usado tus 3 refinamientos con IA de hoy",
    unlock_premium: "Desbloquear Premium",
    processing_payment: "Procesando pago…",
    payment_success: "¡Pago exitoso! Premium activado.",
    payment_pending: "Verificando pago…",
    payment_failed: "El pago no se completó",
    premium_active: "Premium activo",
    points_earned: "+{n} pts",
    onboard_welcome_title: "Bienvenido a Diálogo Sereno",
    onboard_welcome_body: "Esta app no es solo para aprender CNV — es tu coach de IA para resolver conflictos reales en 60 segundos.",
    onboard_bullet_coach: "Coach IA para conflictos reales",
    onboard_bullet_coach_desc: "Simula una conversación difícil (con tu pareja, jefe, hijo…) y recibe guía empática en tiempo real.",
    onboard_bullet_journal: "Diario CNV + reescritura IA",
    onboard_bullet_journal_desc: "Escribe lo que sientes en crudo y la IA lo transforma en un mensaje listo para enviar.",
    onboard_coach_title: "Prueba tu coach IA",
    onboard_coach_body: "Antes que nada, la joya de la app.",
    onboard_coach_pitch: "Escribe cualquier situación difícil y tu coach de IA te guía en tiempo real — como tener a Marshall Rosenberg en el bolsillo.",
    onboard_coach_bullet1: "Familia, pareja, trabajo, escuela: 5 contextos",
    onboard_coach_bullet2: "Powered by Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 conversaciones gratis al día",
    onboard_coach_try: "Probar coach IA ahora",
    onboard_coach_later: "Después, quiero ver el diario",
    onboard_step1: "Escribe tu situación",
    onboard_step2: "Refinar con IA",
    onboard_step3: "Copia y envía",
    onboard_write_below: "Escribe una situación real (o usa el ejemplo):",
    onboard_use_example: "Usar ejemplo",
    onboard_next: "Siguiente",
    onboard_refine_now: "Refinar con IA",
    onboard_copy: "Copiar mensaje",
    onboard_copied: "Copiado al portapapeles",
    onboard_finish: "Empezar a usar la app",
    skip: "Saltar",
    locked_content: "Contenido Premium",
    upgrade_to_unlock: "Mejora a Premium para desbloquear",
    refer_friend: "Invita a un amigo",
    giraffe_tip: "Consejo del Bonobo",
    quick_exercise: "Ejercicio rápido (2 min)",
    daily_challenge: "Desafío del día",
    evening_reflection: "Reflexión nocturna",
    mark_done: "Marcar como hecho",
    done_today: "Hecho hoy",
    save_answer: "Guardar respuesta",
    write_answer: "Escribe tu respuesta…",
    needs_at_play: "Necesidades en juego",
    reflection_locked: "Disponible a partir de las 18:00",
    context_family: "Familia",
    context_work: "Trabajo",
    context_love: "Amor",
    context_friends: "Amigos",
    context_school: "Escuela",
    progress_rings: "Tu progreso por área",
    review_completed: "Repasar ejercicios completados",
    hide_completed: "Ocultar completados",
    exercises_completed_title: "¡Has completado todos los ejercicios aquí!",
    exercises_completed_body: "Prueba otra sección desde los filtros arriba, o repasa los que ya has hecho.",
    see_all_exercises: "Ver otros ejercicios",
    refer_desc: "Ambos reciben {days} días de Básico gratis cuando se registra con tu código.",
    your_referral_code: "Tu código",
    copy_link: "Copiar enlace",
    copied: "Copiado",
    friends_referred: "Amigos invitados",
    days_earned_free: "Días gratis ganados",
    invalid_referral: "Código de invitación no válido",
    referral_code_optional: "Código de invitación (opcional)",
    referral_applied: "🎉 ¡Código aplicado! Recibirás 30 días de Básico gratis.",
  },
  en: {
    app_name: "Serene Dialogue",
    tagline: "Practice Nonviolent Communication",
    hero_title: "Speak from the heart, listen without judging",
    hero_sub: "Learn the 4 NVC steps and practice with family, partner, work, relationships and school — with an AI coach.",
    get_started: "Get started",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Name",
    language: "Language",
    no_account: "No account?",
    have_account: "Already have an account?",
    dashboard: "Home",
    study: "Study",
    exercises: "Exercises",
    practice: "Chat Bonobo 🐒",
    journal: "Journal",
    library: "Library",
    welcome: "Welcome",
    steps_completed: "Steps completed",
    exercises_solved: "Exercises solved",
    journal_entries: "Journal entries",
    accuracy: "Accuracy",
    next_step: "Next step",
    continue_learning: "Continue learning",
    start_learning: "Start learning",
    the_four_steps: "The 4 NVC steps",
    key_points: "Key points",
    mark_complete: "Mark as complete",
    completed: "Completed",
    correct: "Correct!",
    incorrect: "Try again",
    show_explanation: "Show explanation",
    next_exercise: "Next",
    prev_exercise: "Previous",
    choose_context: "Choose a context",
    scenario: "Scenario",
    optional_scenario: "Scenario (optional)",
    start_practice: "Start practice",
    send: "Send",
    type_message: "Type your message…",
    coach_thinking: "Coach is thinking…",
    new_entry: "New entry",
    observation: "Observation",
    feeling: "Feeling",
    need: "Need",
    request: "Request",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    no_entries: "No entries yet. Write your first one.",
    context: "Context",
    feelings_met: "Feelings (needs met)",
    feelings_unmet: "Feelings (needs unmet)",
    needs: "Universal needs",
    library_intro: "Expand your emotional and needs vocabulary.",
    saved: "Saved",
    deleted: "Deleted",
    error: "Something went wrong",
    popup_blocked: "Enable pop-ups to open Stripe Checkout.",
    lesson: "Lesson",
    practice_intro: "Choose a context and practice a real conversation with your coach.",
    streak: "Streak",
    days: "days",
    day: "day",
    daily_prompt: "Today's practice",
    empathy: "Empathy",
    all_steps: "All",
    refine_ai: "Refine with AI",
    ai_rewriting: "Rewriting with AI…",
    ai_suggestion: "NVC suggestion",
    use_suggestion: "Use suggestion",
    export_pdf: "Export PDF",
    reminders: "Daily reminders",
    enable_notifications: "Enable notifications",
    notifications_enabled: "Notifications enabled",
    notifications_denied: "Notifications blocked",
    practiced_today: "You practiced today! 🌱",
    streak_fire: "🔥 On fire!",
    streak_milestone_3: "3 days in a row! Keep going.",
    streak_milestone_7: "🔥 A week! Impressive.",
    streak_milestone_14: "🔥🔥 Two weeks! You're building a habit.",
    streak_milestone_30: "🔥🔥🔥 A full month! NVC is part of you now.",
    streak_milestone_100: "🌟 100 days! You are an NVC master.",
    reminder_hour: "Reminder hour",
    reminder_off: "No reminder",
    send_test_push: "Send test",
    push_sent: "Notification sent",
    answers: "answers",
    month: "month",
    most_popular: "Most popular",
    unlimited: "Unlimited",
    choose_plan: "Choose your plan",
    points_to_basic: "Points for Basic plan",
    plan: "Plan",
    free_plan: "Free Plan",
    premium_plan: "Premium",
    upgrade: "Upgrade to Premium",
    upgrade_now: "Upgrade now",
    current_plan: "Your plan",
    days_left: "days left",
    points: "Points",
    redeem_points: "Redeem 500 points",
    points_to_premium: "Points to Premium",
    or_pay: "Or pay with card",
    pay_499: "$4.99 · 30 days",
    premium_features: "Premium benefits",
    premium_feat_1: "Advanced context exercises (25+)",
    premium_feat_2: "Unlimited AI coach (free: 5/day)",
    premium_feat_3: "Unlimited AI journal refine (free: 3/day)",
    premium_feat_4: "No paywalls or interruptions",
    limit_reached: "Daily limit reached",
    limit_reached_ai: "You've used your 5 AI coach messages today",
    limit_reached_rewrite: "You've used your 3 AI refines today",
    unlock_premium: "Unlock Premium",
    processing_payment: "Processing payment…",
    payment_success: "Payment successful! Premium activated.",
    payment_pending: "Verifying payment…",
    payment_failed: "Payment did not complete",
    premium_active: "Premium active",
    points_earned: "+{n} pts",
    onboard_welcome_title: "Welcome to Serene Dialogue",
    onboard_welcome_body: "This app is not just for learning NVC — it's your AI coach for solving real-life conflicts in 60 seconds.",
    onboard_bullet_coach: "AI coach for real conflicts",
    onboard_bullet_coach_desc: "Simulate a hard conversation (partner, boss, child…) and get empathic guidance in real time.",
    onboard_bullet_journal: "NVC journal + AI rewriter",
    onboard_bullet_journal_desc: "Write what you feel raw and the AI transforms it into a ready-to-send message.",
    onboard_coach_title: "Try your AI coach",
    onboard_coach_body: "First, the crown jewel of the app.",
    onboard_coach_pitch: "Type any difficult situation and your AI coach guides you in real time — like having Marshall Rosenberg in your pocket.",
    onboard_coach_bullet1: "Family, partner, work, school: 5 contexts",
    onboard_coach_bullet2: "Powered by Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 free conversations per day",
    onboard_coach_try: "Try AI coach now",
    onboard_coach_later: "Later, show me the journal",
    onboard_step1: "Write your situation",
    onboard_step2: "Refine with AI",
    onboard_step3: "Copy and send",
    onboard_write_below: "Write a real situation (or use the example):",
    onboard_use_example: "Use example",
    onboard_next: "Next",
    onboard_refine_now: "Refine with AI",
    onboard_copy: "Copy message",
    onboard_copied: "Copied to clipboard",
    onboard_finish: "Start using the app",
    skip: "Skip",
    locked_content: "Premium content",
    upgrade_to_unlock: "Upgrade to Premium to unlock",
    refer_friend: "Refer a friend",
    giraffe_tip: "Bonobo's Tip",
    quick_exercise: "Quick Exercise (2 min)",
    daily_challenge: "Daily Challenge",
    evening_reflection: "Evening Reflection",
    mark_done: "Mark as done",
    done_today: "Done today",
    save_answer: "Save answer",
    write_answer: "Write your answer…",
    needs_at_play: "Needs at play",
    reflection_locked: "Available after 6:00 PM",
    context_family: "Family",
    context_work: "Work",
    context_love: "Love",
    context_friends: "Friends",
    context_school: "School",
    progress_rings: "Your progress by area",
    review_completed: "Review completed exercises",
    hide_completed: "Hide completed",
    exercises_completed_title: "You've completed all exercises here!",
    exercises_completed_body: "Try another section from the filters above, or review the ones you've done.",
    see_all_exercises: "See other exercises",
    refer_desc: "You both get {days} days of Basic free when they sign up with your code.",
    your_referral_code: "Your code",
    copy_link: "Copy link",
    copied: "Copied",
    friends_referred: "Friends invited",
    days_earned_free: "Free days earned",
    invalid_referral: "Invalid referral code",
    referral_code_optional: "Referral code (optional)",
    referral_applied: "🎉 Code applied! You'll get 30 days of Basic free.",
  },
  it: {
    app_name: "Dialogo Sereno",
    tagline: "Pratica la Comunicazione Nonviolenta",
    hero_title: "Parla dal cuore, ascolta senza giudicare",
    hero_sub: "Impara i 4 passi della CNV e pratica con famiglia, partner, lavoro, relazioni e scuola — con un coach IA.",
    get_started: "Inizia",
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    email: "Email",
    password: "Password",
    name: "Nome",
    language: "Lingua",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    dashboard: "Home",
    study: "Studiare",
    exercises: "Esercizi",
    practice: "Chat Bonobo 🐒",
    journal: "Diario",
    library: "Biblioteca",
    welcome: "Benvenuto",
    steps_completed: "Passi completati",
    exercises_solved: "Esercizi risolti",
    journal_entries: "Voci del diario",
    accuracy: "Precisione",
    next_step: "Prossimo passo",
    continue_learning: "Continua ad imparare",
    start_learning: "Inizia a imparare",
    the_four_steps: "I 4 passi della CNV",
    key_points: "Punti chiave",
    mark_complete: "Segna come completato",
    completed: "Completato",
    correct: "Corretto!",
    incorrect: "Riprova",
    show_explanation: "Mostra spiegazione",
    next_exercise: "Successivo",
    prev_exercise: "Precedente",
    choose_context: "Scegli un contesto",
    scenario: "Scenario",
    optional_scenario: "Scenario (opzionale)",
    start_practice: "Inizia la pratica",
    send: "Invia",
    type_message: "Scrivi il tuo messaggio…",
    coach_thinking: "Il coach sta pensando…",
    new_entry: "Nuova voce",
    observation: "Osservazione",
    feeling: "Sentimento",
    need: "Bisogno",
    request: "Richiesta",
    notes: "Note",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    no_entries: "Nessuna voce ancora. Scrivi la prima.",
    context: "Contesto",
    feelings_met: "Sentimenti (bisogni soddisfatti)",
    feelings_unmet: "Sentimenti (bisogni non soddisfatti)",
    needs: "Bisogni universali",
    library_intro: "Amplia il tuo vocabolario emotivo e dei bisogni.",
    saved: "Salvato",
    deleted: "Eliminato",
    error: "Qualcosa è andato storto",
    popup_blocked: "Abilita i pop-up per aprire Stripe Checkout.",
    lesson: "Lezione",
    practice_intro: "Scegli un contesto e pratica una conversazione reale con il tuo coach.",
    streak: "Serie",
    days: "giorni",
    day: "giorno",
    daily_prompt: "Pratica di oggi",
    empathy: "Empatia",
    all_steps: "Tutti",
    refine_ai: "Rifinire con IA",
    ai_rewriting: "Riscrivendo con IA…",
    ai_suggestion: "Suggerimento CNV",
    use_suggestion: "Usa suggerimento",
    export_pdf: "Esporta PDF",
    reminders: "Promemoria giornalieri",
    enable_notifications: "Attiva notifiche",
    notifications_enabled: "Notifiche attivate",
    notifications_denied: "Notifiche bloccate",
    practiced_today: "Hai praticato oggi! 🌱",
    streak_fire: "🔥 A tutta!",
    streak_milestone_3: "3 giorni di fila! Continua così.",
    streak_milestone_7: "🔥 Una settimana! Impressionante.",
    streak_milestone_14: "🔥🔥 Due settimane! Stai costruendo un'abitudine.",
    streak_milestone_30: "🔥🔥🔥 Un mese intero! La CNV è parte di te.",
    streak_milestone_100: "🌟 100 giorni! Sei un maestro della CNV.",
    reminder_hour: "Ora del promemoria",
    reminder_off: "Nessun promemoria",
    send_test_push: "Invia test",
    push_sent: "Notifica inviata",
    answers: "risposte",
    month: "mese",
    most_popular: "Più popolare",
    unlimited: "Illimitato",
    choose_plan: "Scegli il tuo piano",
    points_to_basic: "Punti per piano Base",
    plan: "Piano",
    free_plan: "Piano Free",
    premium_plan: "Premium",
    upgrade: "Passa a Premium",
    upgrade_now: "Passa ora",
    current_plan: "Il tuo piano",
    days_left: "giorni rimanenti",
    points: "Punti",
    redeem_points: "Riscatta 500 punti",
    points_to_premium: "Punti per Premium",
    or_pay: "O paga con carta",
    pay_499: "$4.99 · 30 giorni",
    premium_features: "Vantaggi Premium",
    premium_feat_1: "Esercizi avanzati per contesto (25+)",
    premium_feat_2: "Coach IA illimitato (free: 5/giorno)",
    premium_feat_3: "Rifinire diario con IA illimitato (free: 3/giorno)",
    premium_feat_4: "Nessun paywall né interruzioni",
    limit_reached: "Limite giornaliero raggiunto",
    limit_reached_ai: "Hai usato i tuoi 5 messaggi al coach IA di oggi",
    limit_reached_rewrite: "Hai usato le tue 3 rifiniture IA di oggi",
    unlock_premium: "Sblocca Premium",
    processing_payment: "Elaborazione pagamento…",
    payment_success: "Pagamento riuscito! Premium attivato.",
    payment_pending: "Verifica del pagamento…",
    payment_failed: "Pagamento non completato",
    premium_active: "Premium attivo",
    points_earned: "+{n} pts",
    onboard_welcome_title: "Benvenuto in Dialogo Sereno",
    onboard_welcome_body: "Questa app non è solo per imparare la CNV — è il tuo coach IA per risolvere conflitti reali in 60 secondi.",
    onboard_bullet_coach: "Coach IA per conflitti reali",
    onboard_bullet_coach_desc: "Simula una conversazione difficile (partner, capo, figlio…) e ricevi guida empatica in tempo reale.",
    onboard_bullet_journal: "Diario CNV + riscrittura IA",
    onboard_bullet_journal_desc: "Scrivi ciò che senti grezzo e l'IA lo trasforma in un messaggio pronto da inviare.",
    onboard_coach_title: "Prova il tuo coach IA",
    onboard_coach_body: "Prima di tutto, il gioiello dell'app.",
    onboard_coach_pitch: "Scrivi una situazione difficile e il tuo coach IA ti guida in tempo reale — come avere Marshall Rosenberg in tasca.",
    onboard_coach_bullet1: "Famiglia, partner, lavoro, scuola: 5 contesti",
    onboard_coach_bullet2: "Powered by Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 conversazioni gratis al giorno",
    onboard_coach_try: "Prova il coach IA ora",
    onboard_coach_later: "Dopo, mostrami il diario",
    onboard_step1: "Scrivi la tua situazione",
    onboard_step2: "Rifinire con IA",
    onboard_step3: "Copia e invia",
    onboard_write_below: "Scrivi una situazione reale (o usa l'esempio):",
    onboard_use_example: "Usa esempio",
    onboard_next: "Avanti",
    onboard_refine_now: "Rifinire con IA",
    onboard_copy: "Copia messaggio",
    onboard_copied: "Copiato negli appunti",
    onboard_finish: "Inizia a usare l'app",
    skip: "Salta",
    locked_content: "Contenuto Premium",
    upgrade_to_unlock: "Passa a Premium per sbloccare",
    refer_friend: "Invita un amico",
    giraffe_tip: "Consiglio del Bonobo",
    quick_exercise: "Esercizio Rapido (2 min)",
    daily_challenge: "Sfida del Giorno",
    evening_reflection: "Riflessione Serale",
    mark_done: "Segna come fatto",
    done_today: "Fatto oggi",
    save_answer: "Salva risposta",
    write_answer: "Scrivi la tua risposta…",
    needs_at_play: "Bisogni in gioco",
    reflection_locked: "Disponibile dopo le 18:00",
    context_family: "Famiglia",
    context_work: "Lavoro",
    context_love: "Amore",
    context_friends: "Amici",
    context_school: "Scuola",
    progress_rings: "Il tuo progresso per area",
    review_completed: "Rivedi esercizi completati",
    hide_completed: "Nascondi completati",
    exercises_completed_title: "Hai completato tutti gli esercizi qui!",
    exercises_completed_body: "Prova un'altra sezione dai filtri sopra, o rivedi quelli che hai già fatto.",
    see_all_exercises: "Vedi altri esercizi",
    refer_desc: "Entrambi ricevete {days} giorni di Base gratis quando si registra con il tuo codice.",
    your_referral_code: "Il tuo codice",
    copy_link: "Copia link",
    copied: "Copiato",
    friends_referred: "Amici invitati",
    days_earned_free: "Giorni gratuiti guadagnati",
    invalid_referral: "Codice invito non valido",
    referral_code_optional: "Codice invito (opzionale)",
    referral_applied: "🎉 Codice applicato! Riceverai 30 giorni di Base gratis.",
  },

  // ---------- Portuguese ----------
  pt: {
    app_name: "Diálogo Sereno",
    tagline: "Pratique Comunicação Não Violenta",
    hero_title: "Fale do coração, ouça sem julgar",
    hero_sub: "Aprenda os 4 passos da CNV e pratique com família, parceiro, trabalho, relações e escola — com um coach de IA.",
    get_started: "Começar",
    login: "Entrar",
    register: "Registar",
    logout: "Sair",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    language: "Idioma",
    no_account: "Sem conta?",
    have_account: "Já tem conta?",
    dashboard: "Início",
    study: "Estudar",
    exercises: "Exercícios",
    practice: "Chat Bonobo 🐒",
    journal: "Diário",
    library: "Biblioteca",
    welcome: "Bem-vindo",
    streak: "Sequência", days: "dias", day: "dia",
    daily_prompt: "Prática do dia",
    empathy: "Empatia", all_steps: "Todos",
    plan: "Plano", free_plan: "Grátis", premium_plan: "Premium",
    upgrade: "Melhorar", upgrade_now: "Melhorar agora",
    current_plan: "Seu plano", days_left: "dias restantes",
    points: "Pontos", answers: "respostas", month: "mês",
    most_popular: "Mais popular", unlimited: "Ilimitado",
    choose_plan: "Escolha seu plano",
    points_to_basic: "Pontos para plano Básico",
    redeem_points: "Resgatar 500 pontos",
    limit_reached: "Limite diário atingido",
    limit_reached_ai: "Você usou suas 5 mensagens do coach IA de hoje",
    limit_reached_rewrite: "Você usou suas 3 refinações IA de hoje",
    unlock_premium: "Desbloquear Premium",
    save: "Guardar", cancel: "Cancelar", delete: "Apagar",
    send: "Enviar", type_message: "Escreva sua mensagem…",
    observation: "Observação", feeling: "Sentimento", need: "Necessidade", request: "Pedido",
    reminder_hour: "Hora do lembrete", reminder_off: "Sem lembrete",
    enable_notifications: "Ativar notificações",
    notifications_enabled: "Notificações ativas",
    skip: "Pular",
    onboard_welcome_title: "Bem-vindo ao Diálogo Sereno",
    onboard_welcome_body: "Este app não é apenas para aprender CNV — é seu coach de IA para resolver conflitos reais em 60 segundos.",
    onboard_coach_try: "Testar coach IA agora",
    onboard_coach_later: "Depois, quero ver o diário",
    onboard_next: "Próximo",
    onboard_refine_now: "Refinar com IA",
    onboard_copy: "Copiar mensagem",
    onboard_finish: "Começar a usar",
    error: "Ocorreu um erro",
    // Extended keys
    the_four_steps: "Os 4 passos da CNV", key_points: "Pontos-chave",
    mark_complete: "Marcar como concluído", completed: "Concluído",
    next_step: "Próximo passo", continue_learning: "Continuar aprendendo", start_learning: "Começar",
    lesson: "Lição", correct: "Correto!", incorrect: "Tente novamente",
    show_explanation: "Ver explicação", next_exercise: "Próximo", prev_exercise: "Anterior",
    choose_context: "Escolha um contexto", scenario: "Cenário", optional_scenario: "Cenário (opcional)",
    start_practice: "Começar prática", coach_thinking: "O coach está pensando…", context: "Contexto",
    practice_intro: "Escolha um contexto e pratique uma conversa real com o coach.",
    new_entry: "Nova entrada", notes: "Notas",
    no_entries: "Nenhuma entrada ainda. Escreva a primeira.",
    refine_ai: "Refinar com IA", ai_rewriting: "Reescrevendo com IA…",
    ai_suggestion: "Sugestão CNV", use_suggestion: "Usar sugestão", export_pdf: "Exportar PDF",
    saved: "Guardado", deleted: "Apagado",
    feelings_met: "Sentimentos (necessidades satisfeitas)",
    feelings_unmet: "Sentimentos (necessidades não satisfeitas)",
    needs: "Necessidades universais",
    library_intro: "Amplie seu vocabulário emocional e de necessidades.",
    premium_features: "Vantagens Premium",
    premium_feat_1: "Exercícios avançados por contexto (25+)",
    premium_feat_2: "Coach IA ilimitado (free: 5/dia)",
    premium_feat_3: "Refinar diário com IA ilimitado (free: 3/dia)",
    premium_feat_4: "Sem paywalls nem interrupções",
    or_pay: "Ou pague com cartão",
    processing_payment: "Processando pagamento…", payment_success: "Pagamento bem-sucedido! Premium ativado.",
    payment_pending: "Verificando pagamento…", payment_failed: "O pagamento não foi concluído",
    premium_active: "Premium ativo", points_earned: "+{n} pts",
    onboard_step1: "Escreva sua situação", onboard_step2: "Refinar com IA", onboard_step3: "Copie e envie",
    onboard_write_below: "Escreva uma situação real (ou use o exemplo):",
    onboard_use_example: "Usar exemplo", onboard_copied: "Copiado para área de transferência",
    onboard_bullet_coach: "Coach IA para conflitos reais",
    onboard_bullet_coach_desc: "Simule uma conversa difícil e receba guia empática em tempo real.",
    onboard_bullet_journal: "Diário CNV + reescrita IA",
    onboard_bullet_journal_desc: "Escreva o que sente e a IA transforma em mensagem pronta.",
    onboard_coach_title: "Teste seu coach IA", onboard_coach_body: "Primeiro, a joia do app.",
    onboard_coach_pitch: "Escreva qualquer situação difícil e o coach IA guia em tempo real.",
    onboard_coach_bullet1: "Família, parceiro, trabalho, escola: 5 contextos",
    onboard_coach_bullet2: "Powered by Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 conversas grátis por dia",
    send_test_push: "Enviar teste", push_sent: "Notificação enviada",
    reminders: "Lembretes diários", notifications_denied: "Notificações bloqueadas",
    locked_content: "Conteúdo Premium", upgrade_to_unlock: "Passe para Premium para desbloquear",
    refer_friend: "Convide um amigo",
    refer_desc: "Ambos ganham {days} dias de Básico grátis quando ele se cadastra com seu código.",
    your_referral_code: "Seu código", copy_link: "Copiar link", copied: "Copiado",
    friends_referred: "Amigos convidados", days_earned_free: "Dias grátis ganhos",
    invalid_referral: "Código de convite inválido", referral_code_optional: "Código de convite (opcional)",
    referral_applied: "🎉 Código aplicado! Você receberá 30 dias de Básico grátis.",
    steps_completed: "Passos concluídos", exercises_solved: "Exercícios resolvidos",
    journal_entries: "Entradas do diário", accuracy: "Precisão",
    tagline: "Pratique CNV",
    hero_title: "Fale do coração, ouça sem julgar",
    hero_sub: "Aprenda os 4 passos da CNV e pratique com família, parceiro, trabalho, relações e escola — com um coach de IA.",
    streak_fire: "🔥 Em chamas!",
    streak_milestone_3: "3 dias seguidos! Continue assim.",
    streak_milestone_7: "🔥 Uma semana! Impressionante.",
    streak_milestone_14: "🔥🔥 Duas semanas! Você está transformando um hábito.",
    streak_milestone_30: "🔥🔥🔥 Um mês inteiro! Comunicação CNV se tornou parte de você.",
    streak_milestone_100: "🌟 100 dias! Você é um mestre da CNV.",
  },

  // ---------- German ----------
  de: {
    app_name: "Serener Dialog",
    tagline: "Übe Gewaltfreie Kommunikation",
    hero_title: "Sprich aus dem Herzen, höre ohne zu urteilen",
    hero_sub: "Lerne die 4 GFK-Schritte und übe mit Familie, Partner, Arbeit, Beziehungen und Schule — mit einem KI-Coach.",
    get_started: "Loslegen",
    login: "Anmelden", register: "Registrieren", logout: "Abmelden",
    email: "E-Mail", password: "Passwort", name: "Name", language: "Sprache",
    no_account: "Noch kein Konto?", have_account: "Bereits ein Konto?",
    dashboard: "Start", study: "Lernen", exercises: "Übungen",
    practice: "Chat Bonobo 🐒", journal: "Tagebuch", library: "Bibliothek",
    welcome: "Willkommen",
    streak: "Serie", days: "Tage", day: "Tag",
    daily_prompt: "Tägliche Übung",
    empathy: "Empathie", all_steps: "Alle",
    plan: "Plan", free_plan: "Kostenlos", premium_plan: "Premium",
    upgrade: "Upgrade", upgrade_now: "Jetzt upgraden",
    current_plan: "Dein Plan", days_left: "Tage übrig",
    points: "Punkte", answers: "Antworten", month: "Monat",
    most_popular: "Am beliebtesten", unlimited: "Unbegrenzt",
    choose_plan: "Wähle deinen Plan",
    points_to_basic: "Punkte für Basic-Plan",
    redeem_points: "500 Punkte einlösen",
    limit_reached: "Tageslimit erreicht",
    limit_reached_ai: "Du hast deine 5 KI-Coach-Nachrichten heute aufgebraucht",
    limit_reached_rewrite: "Du hast deine 3 KI-Verfeinerungen heute aufgebraucht",
    unlock_premium: "Premium freischalten",
    save: "Speichern", cancel: "Abbrechen", delete: "Löschen",
    send: "Senden", type_message: "Schreibe deine Nachricht…",
    observation: "Beobachtung", feeling: "Gefühl", need: "Bedürfnis", request: "Bitte",
    reminder_hour: "Erinnerungsstunde", reminder_off: "Keine Erinnerung",
    enable_notifications: "Benachrichtigungen aktivieren",
    notifications_enabled: "Benachrichtigungen aktiv",
    skip: "Überspringen",
    onboard_welcome_title: "Willkommen bei Serener Dialog",
    onboard_welcome_body: "Diese App dient nicht nur zum Lernen von GFK — sie ist dein KI-Coach für echte Konflikte in 60 Sekunden.",
    onboard_coach_try: "KI-Coach jetzt testen",
    onboard_coach_later: "Später, zeig mir das Tagebuch",
    onboard_next: "Weiter",
    onboard_refine_now: "Mit KI verfeinern",
    onboard_copy: "Nachricht kopieren",
    onboard_finish: "App starten",
    error: "Ein Fehler ist aufgetreten",
    the_four_steps: "Die 4 GFK-Schritte", key_points: "Kernpunkte",
    mark_complete: "Als erledigt markieren", completed: "Erledigt",
    next_step: "Nächster Schritt", continue_learning: "Weiterlernen", start_learning: "Loslegen",
    lesson: "Lektion", correct: "Richtig!", incorrect: "Nochmal versuchen",
    show_explanation: "Erklärung zeigen", next_exercise: "Weiter", prev_exercise: "Zurück",
    choose_context: "Wähle einen Kontext", scenario: "Szenario", optional_scenario: "Szenario (optional)",
    start_practice: "Übung starten", coach_thinking: "Der Coach denkt nach…", context: "Kontext",
    practice_intro: "Wähle einen Kontext und übe ein echtes Gespräch mit deinem Coach.",
    new_entry: "Neuer Eintrag", notes: "Notizen",
    no_entries: "Noch keine Einträge. Schreibe deinen ersten.",
    refine_ai: "Mit KI verfeinern", ai_rewriting: "KI schreibt um…",
    ai_suggestion: "GFK-Vorschlag", use_suggestion: "Vorschlag verwenden", export_pdf: "PDF exportieren",
    saved: "Gespeichert", deleted: "Gelöscht",
    feelings_met: "Gefühle (erfüllte Bedürfnisse)",
    feelings_unmet: "Gefühle (unerfüllte Bedürfnisse)",
    needs: "Universelle Bedürfnisse",
    library_intro: "Erweitere dein Vokabular für Gefühle und Bedürfnisse.",
    premium_features: "Premium-Vorteile",
    premium_feat_1: "Erweiterte Kontext-Übungen (25+)",
    premium_feat_2: "Unbegrenzter KI-Coach (Free: 5/Tag)",
    premium_feat_3: "Unbegrenzte KI-Verfeinerung (Free: 3/Tag)",
    premium_feat_4: "Keine Paywalls oder Unterbrechungen",
    or_pay: "Oder mit Karte bezahlen",
    processing_payment: "Zahlung wird verarbeitet…", payment_success: "Zahlung erfolgreich! Premium aktiviert.",
    payment_pending: "Zahlung wird überprüft…", payment_failed: "Zahlung nicht abgeschlossen",
    premium_active: "Premium aktiv", points_earned: "+{n} Pkt",
    onboard_step1: "Schreibe deine Situation", onboard_step2: "Mit KI verfeinern", onboard_step3: "Kopieren & senden",
    onboard_write_below: "Schreibe eine echte Situation (oder nutze das Beispiel):",
    onboard_use_example: "Beispiel verwenden", onboard_copied: "In Zwischenablage kopiert",
    onboard_bullet_coach: "KI-Coach für echte Konflikte",
    onboard_bullet_coach_desc: "Simuliere ein schwieriges Gespräch und erhalte empathische Führung in Echtzeit.",
    onboard_bullet_journal: "GFK-Tagebuch + KI-Umschreiber",
    onboard_bullet_journal_desc: "Schreibe roh, was du fühlst, und die KI macht daraus eine sendbare Nachricht.",
    onboard_coach_title: "Probiere deinen KI-Coach", onboard_coach_body: "Zuerst das Herzstück der App.",
    onboard_coach_pitch: "Beschreibe jede schwierige Situation und dein KI-Coach führt dich in Echtzeit.",
    onboard_coach_bullet1: "Familie, Partner, Arbeit, Schule: 5 Kontexte",
    onboard_coach_bullet2: "Powered by Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 kostenlose Gespräche pro Tag",
    send_test_push: "Test senden", push_sent: "Benachrichtigung gesendet",
    reminders: "Tägliche Erinnerungen", notifications_denied: "Benachrichtigungen blockiert",
    locked_content: "Premium-Inhalt", upgrade_to_unlock: "Upgrade auf Premium zum Freischalten",
    refer_friend: "Freund einladen",
    refer_desc: "Ihr bekommt beide {days} Tage Basis gratis, wenn er sich mit deinem Code anmeldet.",
    your_referral_code: "Dein Code", copy_link: "Link kopieren", copied: "Kopiert",
    friends_referred: "Eingeladene Freunde", days_earned_free: "Verdiente Gratis-Tage",
    invalid_referral: "Ungültiger Einladungscode", referral_code_optional: "Einladungscode (optional)",
    referral_applied: "🎉 Code angewendet! Du erhältst 30 Tage Basis kostenlos.",
    steps_completed: "Schritte erledigt", exercises_solved: "Übungen gelöst",
    journal_entries: "Tagebucheinträge", accuracy: "Genauigkeit",
    streak_fire: "🔥 Du bist auf Feuer!",
    streak_milestone_3: "3 Tage in Folge! Weiter so.",
    streak_milestone_7: "🔥 Eine Woche! Beeindruckend.",
    streak_milestone_14: "🔥🔥 Zwei Wochen! Du baust eine Gewohnheit auf.",
    streak_milestone_30: "🔥🔥🔥 Ein ganzer Monat! GFK ist Teil von dir.",
    streak_milestone_100: "🌟 100 Tage! Du bist ein GFK-Meister.",
  },

  // ---------- Simplified Chinese ----------
  zh: {
    app_name: "宁静对话",
    tagline: "练习非暴力沟通",
    hero_title: "用心说话,不带评判地聆听",
    hero_sub: "学习非暴力沟通的4个步骤,并在家庭、伴侣、工作、关系和学校中练习——由AI教练指导。",
    get_started: "开始",
    login: "登录", register: "注册", logout: "退出",
    email: "电子邮件", password: "密码", name: "姓名", language: "语言",
    no_account: "没有账户?", have_account: "已有账户?",
    dashboard: "首页", study: "学习", exercises: "练习",
    practice: "倭黑猩猩聊天 🐒", journal: "日记", library: "词库",
    welcome: "欢迎",
    streak: "连续", days: "天", day: "天",
    daily_prompt: "每日练习",
    empathy: "共情", all_steps: "全部",
    plan: "套餐", free_plan: "免费", premium_plan: "高级",
    upgrade: "升级", upgrade_now: "立即升级",
    current_plan: "您的套餐", days_left: "剩余天数",
    points: "积分", answers: "次回复", month: "月",
    most_popular: "最受欢迎", unlimited: "无限",
    choose_plan: "选择您的套餐",
    points_to_basic: "兑换基础套餐所需积分",
    redeem_points: "兑换500积分",
    limit_reached: "已达今日上限",
    limit_reached_ai: "您今日的5次AI教练消息已用完",
    limit_reached_rewrite: "您今日的3次AI改写已用完",
    unlock_premium: "解锁高级版",
    save: "保存", cancel: "取消", delete: "删除",
    send: "发送", type_message: "输入您的消息…",
    observation: "观察", feeling: "感受", need: "需求", request: "请求",
    reminder_hour: "提醒时间", reminder_off: "无提醒",
    enable_notifications: "开启通知",
    notifications_enabled: "通知已开启",
    skip: "跳过",
    onboard_welcome_title: "欢迎使用宁静对话",
    onboard_welcome_body: "这款应用不仅是学习非暴力沟通的工具——它是您的AI教练,60秒解决真实冲突。",
    onboard_coach_try: "立即试用AI教练",
    onboard_coach_later: "稍后,先看日记",
    onboard_next: "下一步",
    onboard_refine_now: "AI改写",
    onboard_copy: "复制消息",
    onboard_finish: "开始使用",
    error: "发生错误",
    the_four_steps: "非暴力沟通的4个步骤", key_points: "要点",
    mark_complete: "标记为完成", completed: "已完成",
    next_step: "下一步", continue_learning: "继续学习", start_learning: "开始学习",
    lesson: "课程", correct: "正确!", incorrect: "再试一次",
    show_explanation: "查看解释", next_exercise: "下一题", prev_exercise: "上一题",
    choose_context: "选择场景", scenario: "情景", optional_scenario: "情景(可选)",
    start_practice: "开始练习", coach_thinking: "教练思考中…", context: "场景",
    practice_intro: "选择场景,与教练进行真实对话练习。",
    new_entry: "新条目", notes: "备注",
    no_entries: "还没有条目,写下第一条吧。",
    refine_ai: "AI改写", ai_rewriting: "AI改写中…",
    ai_suggestion: "非暴力沟通建议", use_suggestion: "使用建议", export_pdf: "导出PDF",
    saved: "已保存", deleted: "已删除",
    feelings_met: "感受(需求已满足)", feelings_unmet: "感受(需求未满足)", needs: "普遍需求",
    library_intro: "扩展你的情绪和需求词汇。",
    premium_features: "高级特权",
    premium_feat_1: "情境高级练习(25+)",
    premium_feat_2: "无限AI教练(免费:5/天)",
    premium_feat_3: "无限AI改写(免费:3/天)",
    premium_feat_4: "无付费墙或中断",
    or_pay: "或使用卡片付款",
    processing_payment: "处理付款中…", payment_success: "付款成功!已激活高级版。",
    payment_pending: "验证付款中…", payment_failed: "付款未完成",
    premium_active: "高级版已启用", points_earned: "+{n} 分",
    onboard_step1: "写下你的情况", onboard_step2: "AI改写", onboard_step3: "复制并发送",
    onboard_write_below: "写下真实情况(或使用示例):",
    onboard_use_example: "使用示例", onboard_copied: "已复制到剪贴板",
    onboard_bullet_coach: "AI教练解决真实冲突",
    onboard_bullet_coach_desc: "模拟难对话,实时获得共情指导。",
    onboard_bullet_journal: "非暴力沟通日记+AI改写",
    onboard_bullet_journal_desc: "写下真实感受,AI转化为可发送的信息。",
    onboard_coach_title: "试用AI教练", onboard_coach_body: "首先,应用的核心宝石。",
    onboard_coach_pitch: "描述任何困难情况,AI教练实时引导你。",
    onboard_coach_bullet1: "家庭、伴侣、工作、学校:5个场景",
    onboard_coach_bullet2: "由 Claude Sonnet 4.5 驱动",
    onboard_coach_bullet3: "每日5次免费对话",
    send_test_push: "发送测试", push_sent: "已发送通知",
    reminders: "每日提醒", notifications_denied: "通知已被阻止",
    locked_content: "高级内容", upgrade_to_unlock: "升级到高级版解锁",
    refer_friend: "邀请好友",
    refer_desc: "好友用你的邀请码注册,双方都获得{days}天免费基础版。",
    your_referral_code: "你的邀请码", copy_link: "复制链接", copied: "已复制",
    friends_referred: "已邀请好友", days_earned_free: "已获得免费天数",
    invalid_referral: "邀请码无效", referral_code_optional: "邀请码(可选)",
    referral_applied: "🎉 邀请码已应用!你将获得30天免费基础版。",
    steps_completed: "已完成步骤", exercises_solved: "已解练习",
    journal_entries: "日记条目", accuracy: "准确率",
    streak_fire: "🔥 火力全开!",
    streak_milestone_3: "连续3天!继续加油。",
    streak_milestone_7: "🔥 一周了!令人印象深刻。",
    streak_milestone_14: "🔥🔥 两周了!你正在养成习惯。",
    streak_milestone_30: "🔥🔥🔥 整整一个月!非暴力沟通已成为你的一部分。",
    streak_milestone_100: "🌟 100天!你是非暴力沟通大师。",
  },

  // ---------- Russian ----------
  ru: {
    app_name: "Спокойный Диалог",
    tagline: "Практикуйте ненасильственное общение",
    hero_title: "Говорите от сердца, слушайте без осуждения",
    hero_sub: "Изучите 4 шага ННО и практикуйтесь с семьёй, партнёром, работой, отношениями и школой — с ИИ-коучем.",
    get_started: "Начать",
    login: "Войти", register: "Регистрация", logout: "Выйти",
    email: "Электронная почта", password: "Пароль", name: "Имя", language: "Язык",
    no_account: "Нет аккаунта?", have_account: "Уже есть аккаунт?",
    dashboard: "Главная", study: "Учиться", exercises: "Упражнения",
    practice: "Чат Бонобо 🐒", journal: "Дневник", library: "Библиотека",
    welcome: "Добро пожаловать",
    streak: "Серия", days: "дней", day: "день",
    daily_prompt: "Практика дня",
    empathy: "Эмпатия", all_steps: "Все",
    plan: "Тариф", free_plan: "Бесплатно", premium_plan: "Премиум",
    upgrade: "Улучшить", upgrade_now: "Улучшить сейчас",
    current_plan: "Ваш тариф", days_left: "дней осталось",
    points: "Очки", answers: "ответов", month: "мес",
    most_popular: "Самый популярный", unlimited: "Безлимит",
    choose_plan: "Выберите тариф",
    points_to_basic: "Очков для тарифа Basic",
    redeem_points: "Обменять 500 очков",
    limit_reached: "Дневной лимит достигнут",
    limit_reached_ai: "Вы использовали 5 сообщений ИИ-коучу за сегодня",
    limit_reached_rewrite: "Вы использовали 3 переписывания ИИ за сегодня",
    unlock_premium: "Разблокировать Премиум",
    save: "Сохранить", cancel: "Отмена", delete: "Удалить",
    send: "Отправить", type_message: "Введите сообщение…",
    observation: "Наблюдение", feeling: "Чувство", need: "Потребность", request: "Просьба",
    reminder_hour: "Час напоминания", reminder_off: "Без напоминания",
    enable_notifications: "Включить уведомления",
    notifications_enabled: "Уведомления включены",
    skip: "Пропустить",
    onboard_welcome_title: "Добро пожаловать в Спокойный Диалог",
    onboard_welcome_body: "Это приложение не только для изучения ННО — это ваш ИИ-коуч для решения реальных конфликтов за 60 секунд.",
    onboard_coach_try: "Попробовать ИИ-коуча",
    onboard_coach_later: "Позже, покажи дневник",
    onboard_next: "Далее",
    onboard_refine_now: "Улучшить с ИИ",
    onboard_copy: "Копировать сообщение",
    onboard_finish: "Начать использовать",
    error: "Произошла ошибка",
    the_four_steps: "4 шага ННО", key_points: "Ключевые моменты",
    mark_complete: "Отметить выполненным", completed: "Выполнено",
    next_step: "Следующий шаг", continue_learning: "Продолжить обучение", start_learning: "Начать",
    lesson: "Урок", correct: "Правильно!", incorrect: "Попробуйте снова",
    show_explanation: "Показать объяснение", next_exercise: "Далее", prev_exercise: "Назад",
    choose_context: "Выберите контекст", scenario: "Сценарий", optional_scenario: "Сценарий (необяз.)",
    start_practice: "Начать практику", coach_thinking: "Коуч думает…", context: "Контекст",
    practice_intro: "Выберите контекст и попрактикуйте реальный разговор с коучем.",
    new_entry: "Новая запись", notes: "Заметки",
    no_entries: "Пока нет записей. Напишите первую.",
    refine_ai: "Улучшить с ИИ", ai_rewriting: "ИИ переписывает…",
    ai_suggestion: "Предложение ННО", use_suggestion: "Использовать", export_pdf: "Экспорт PDF",
    saved: "Сохранено", deleted: "Удалено",
    feelings_met: "Чувства (потребности удовлетворены)",
    feelings_unmet: "Чувства (потребности неудовлетворены)",
    needs: "Универсальные потребности",
    library_intro: "Расширьте словарь чувств и потребностей.",
    premium_features: "Премиум-преимущества",
    premium_feat_1: "Продвинутые контекстные упражнения (25+)",
    premium_feat_2: "Безлимитный ИИ-коуч (free: 5/день)",
    premium_feat_3: "Безлимитная ИИ-правка дневника (free: 3/день)",
    premium_feat_4: "Никаких paywalls или прерываний",
    or_pay: "Или оплатите картой",
    processing_payment: "Обработка платежа…", payment_success: "Оплачено! Премиум активирован.",
    payment_pending: "Проверка платежа…", payment_failed: "Платёж не выполнен",
    premium_active: "Премиум активен", points_earned: "+{n} очк.",
    onboard_step1: "Опишите ситуацию", onboard_step2: "Улучшить с ИИ", onboard_step3: "Скопировать и отправить",
    onboard_write_below: "Опишите реальную ситуацию (или используйте пример):",
    onboard_use_example: "Использовать пример", onboard_copied: "Скопировано в буфер",
    onboard_bullet_coach: "ИИ-коуч для реальных конфликтов",
    onboard_bullet_coach_desc: "Симулируйте сложный разговор и получите эмпатичную поддержку в реальном времени.",
    onboard_bullet_journal: "Дневник ННО + ИИ-редактор",
    onboard_bullet_journal_desc: "Напишите как есть — ИИ превратит в готовое сообщение.",
    onboard_coach_title: "Попробуй ИИ-коуча", onboard_coach_body: "Сначала — жемчужина приложения.",
    onboard_coach_pitch: "Опишите любую трудную ситуацию, и ИИ-коуч направит вас в реальном времени.",
    onboard_coach_bullet1: "Семья, партнёр, работа, школа: 5 контекстов",
    onboard_coach_bullet2: "На базе Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 бесплатных бесед в день",
    send_test_push: "Отправить тест", push_sent: "Уведомление отправлено",
    reminders: "Ежедневные напоминания", notifications_denied: "Уведомления заблокированы",
    locked_content: "Премиум-контент", upgrade_to_unlock: "Обновитесь до Премиум",
    refer_friend: "Пригласить друга",
    refer_desc: "Оба получите {days} дней Базового бесплатно, когда друг зарегистрируется с вашим кодом.",
    your_referral_code: "Ваш код", copy_link: "Скопировать ссылку", copied: "Скопировано",
    friends_referred: "Приглашённые друзья", days_earned_free: "Заработано бесплатных дней",
    invalid_referral: "Неверный код приглашения", referral_code_optional: "Код приглашения (необязательно)",
    referral_applied: "🎉 Код применён! Вы получите 30 дней Базового бесплатно.",
    steps_completed: "Шагов выполнено", exercises_solved: "Упражнений решено",
    journal_entries: "Записей в дневнике", accuracy: "Точность",
    streak_fire: "🔥 В ударе!",
    streak_milestone_3: "3 дня подряд! Так держать.",
    streak_milestone_7: "🔥 Целая неделя! Впечатляет.",
    streak_milestone_14: "🔥🔥 Две недели! Формируется привычка.",
    streak_milestone_30: "🔥🔥🔥 Целый месяц! ННО стало частью тебя.",
    streak_milestone_100: "🌟 100 дней! Ты мастер ННО.",
  },

  // ---------- Arabic ----------
  ar: {
    app_name: "حوار هادئ",
    tagline: "تدرب على التواصل اللاعنفي",
    hero_title: "تحدث من القلب واستمع بدون إصدار أحكام",
    hero_sub: "تعلم خطوات التواصل اللاعنفي الأربع وتدرب مع العائلة والشريك والعمل والعلاقات والمدرسة — مع مدرب ذكاء اصطناعي.",
    get_started: "ابدأ",
    login: "تسجيل الدخول", register: "إنشاء حساب", logout: "خروج",
    email: "البريد الإلكتروني", password: "كلمة المرور", name: "الاسم", language: "اللغة",
    no_account: "ليس لديك حساب؟", have_account: "لديك حساب بالفعل؟",
    dashboard: "الرئيسية", study: "الدراسة", exercises: "التمارين",
    practice: "دردشة بونوبو 🐒", journal: "المذكرة", library: "المكتبة",
    welcome: "أهلاً بك",
    streak: "سلسلة", days: "أيام", day: "يوم",
    daily_prompt: "تدريب اليوم",
    empathy: "التعاطف", all_steps: "الكل",
    plan: "الخطة", free_plan: "مجاني", premium_plan: "مميز",
    upgrade: "الترقية", upgrade_now: "ترقية الآن",
    current_plan: "خطتك الحالية", days_left: "أيام متبقية",
    points: "نقاط", answers: "إجابات", month: "شهر",
    most_popular: "الأكثر شعبية", unlimited: "غير محدود",
    choose_plan: "اختر خطتك",
    points_to_basic: "نقاط لخطة أساسية",
    redeem_points: "استبدال 500 نقطة",
    limit_reached: "تم الوصول للحد اليومي",
    limit_reached_ai: "لقد استخدمت 5 رسائل مدرب اليوم",
    limit_reached_rewrite: "لقد استخدمت 3 تحسينات ذكية اليوم",
    unlock_premium: "افتح المميز",
    save: "حفظ", cancel: "إلغاء", delete: "حذف",
    send: "إرسال", type_message: "اكتب رسالتك…",
    observation: "الملاحظة", feeling: "الشعور", need: "الحاجة", request: "الطلب",
    reminder_hour: "ساعة التذكير", reminder_off: "بدون تذكير",
    enable_notifications: "تفعيل الإشعارات",
    notifications_enabled: "الإشعارات مفعلة",
    skip: "تخطي",
    onboard_welcome_title: "أهلاً بك في حوار هادئ",
    onboard_welcome_body: "هذا التطبيق ليس فقط لتعلم التواصل اللاعنفي — إنه مدربك الذكي لحل النزاعات الحقيقية في 60 ثانية.",
    onboard_coach_try: "جرب المدرب الذكي الآن",
    onboard_coach_later: "لاحقاً، أرني المذكرة",
    onboard_next: "التالي",
    onboard_refine_now: "تحسين بالذكاء",
    onboard_copy: "نسخ الرسالة",
    onboard_finish: "ابدأ الاستخدام",
    error: "حدث خطأ",
    the_four_steps: "خطوات التواصل اللاعنفي الأربع", key_points: "النقاط الرئيسية",
    mark_complete: "وضع علامة كمكتمل", completed: "مكتمل",
    next_step: "الخطوة التالية", continue_learning: "متابعة التعلم", start_learning: "ابدأ التعلم",
    lesson: "الدرس", correct: "صحيح!", incorrect: "حاول مرة أخرى",
    show_explanation: "إظهار الشرح", next_exercise: "التالي", prev_exercise: "السابق",
    choose_context: "اختر سياقاً", scenario: "السيناريو", optional_scenario: "السيناريو (اختياري)",
    start_practice: "بدء التدريب", coach_thinking: "المدرب يفكر…", context: "السياق",
    practice_intro: "اختر سياقاً وتدرب على محادثة حقيقية مع المدرب.",
    new_entry: "إدخال جديد", notes: "ملاحظات",
    no_entries: "لا توجد إدخالات بعد. اكتب أولها.",
    refine_ai: "تحسين بالذكاء", ai_rewriting: "الذكاء يعيد الكتابة…",
    ai_suggestion: "اقتراح التواصل اللاعنفي", use_suggestion: "استخدم الاقتراح", export_pdf: "تصدير PDF",
    saved: "تم الحفظ", deleted: "تم الحذف",
    feelings_met: "المشاعر (احتياجات مُلبَّاة)",
    feelings_unmet: "المشاعر (احتياجات غير مُلبَّاة)",
    needs: "الاحتياجات الإنسانية",
    library_intro: "وسّع مفرداتك للمشاعر والاحتياجات.",
    premium_features: "مزايا المميز",
    premium_feat_1: "تمارين سياقية متقدمة (25+)",
    premium_feat_2: "مدرب ذكي بلا حدود (مجاني: 5/يوم)",
    premium_feat_3: "تحسين ذكي لليوميات بلا حدود (مجاني: 3/يوم)",
    premium_feat_4: "بدون إعلانات أو مقاطعات",
    or_pay: "أو ادفع بالبطاقة",
    processing_payment: "جاري معالجة الدفع…", payment_success: "تم الدفع! المميز مفعل.",
    payment_pending: "التحقق من الدفع…", payment_failed: "لم يكتمل الدفع",
    premium_active: "المميز مفعل", points_earned: "+{n} نقطة",
    onboard_step1: "اكتب موقفك", onboard_step2: "تحسين بالذكاء", onboard_step3: "انسخ وأرسل",
    onboard_write_below: "اكتب موقفاً حقيقياً (أو استخدم المثال):",
    onboard_use_example: "استخدم المثال", onboard_copied: "تم النسخ إلى الحافظة",
    onboard_bullet_coach: "مدرب ذكي للنزاعات الحقيقية",
    onboard_bullet_coach_desc: "حاكِ محادثة صعبة واحصل على إرشاد تعاطفي فوراً.",
    onboard_bullet_journal: "يوميات التواصل اللاعنفي + إعادة صياغة ذكية",
    onboard_bullet_journal_desc: "اكتب مشاعرك خاماً ويحوّلها الذكاء إلى رسالة جاهزة.",
    onboard_coach_title: "جرّب المدرب الذكي", onboard_coach_body: "أولاً، جوهرة التطبيق.",
    onboard_coach_pitch: "اكتب أي موقف صعب وسيرشدك المدرب الذكي فوراً.",
    onboard_coach_bullet1: "العائلة، الشريك، العمل، المدرسة: 5 سياقات",
    onboard_coach_bullet2: "مدعوم بـ Claude Sonnet 4.5",
    onboard_coach_bullet3: "5 محادثات مجانية يومياً",
    send_test_push: "إرسال اختبار", push_sent: "تم إرسال الإشعار",
    reminders: "التذكيرات اليومية", notifications_denied: "الإشعارات محظورة",
    locked_content: "محتوى مميز", upgrade_to_unlock: "الترقية للمميز لفتحه",
    refer_friend: "ادعُ صديقًا",
    refer_desc: "كلاكما يحصل على {days} يومًا مجانًا من الأساسي عند التسجيل برمزك.",
    your_referral_code: "رمزك", copy_link: "نسخ الرابط", copied: "تم النسخ",
    friends_referred: "الأصدقاء المدعوون", days_earned_free: "الأيام المجانية المكتسبة",
    invalid_referral: "رمز دعوة غير صالح", referral_code_optional: "رمز الدعوة (اختياري)",
    referral_applied: "🎉 تم تطبيق الرمز! ستحصل على 30 يومًا مجانًا من الأساسي.",
    steps_completed: "الخطوات المكتملة", exercises_solved: "التمارين المحلولة",
    journal_entries: "إدخالات اليوميات", accuracy: "الدقة",
    streak_fire: "🔥 في القمة!",
    streak_milestone_3: "3 أيام متتالية! استمر.",
    streak_milestone_7: "🔥 أسبوع كامل! رائع.",
    streak_milestone_14: "🔥🔥 أسبوعان! أنت تبني عادة.",
    streak_milestone_30: "🔥🔥🔥 شهر كامل! التواصل اللاعنفي أصبح جزءاً منك.",
    streak_milestone_100: "🌟 100 يوم! أنت خبير في التواصل اللاعنفي.",
  },

  // ---------- Hindi ----------
  hi: {
    app_name: "शांत संवाद",
    tagline: "अहिंसक संचार का अभ्यास करें",
    hero_title: "दिल से बोलें, बिना निर्णय के सुनें",
    hero_sub: "अहिंसक संचार के 4 चरण सीखें और परिवार, साथी, कार्य, रिश्तों और स्कूल के साथ अभ्यास करें — AI कोच के साथ।",
    get_started: "शुरू करें",
    login: "लॉग इन", register: "पंजीकरण", logout: "लॉग आउट",
    email: "ईमेल", password: "पासवर्ड", name: "नाम", language: "भाषा",
    no_account: "खाता नहीं है?", have_account: "पहले से खाता है?",
    dashboard: "मुख्य", study: "अध्ययन", exercises: "अभ्यास",
    practice: "बोनोबो चैट 🐒", journal: "डायरी", library: "पुस्तकालय",
    welcome: "स्वागत है",
    streak: "क्रम", days: "दिन", day: "दिन",
    daily_prompt: "आज का अभ्यास",
    empathy: "समानुभूति", all_steps: "सभी",
    plan: "योजना", free_plan: "मुफ्त", premium_plan: "प्रीमियम",
    upgrade: "अपग्रेड", upgrade_now: "अभी अपग्रेड करें",
    current_plan: "आपकी योजना", days_left: "दिन बचे",
    points: "अंक", answers: "उत्तर", month: "माह",
    most_popular: "सबसे लोकप्रिय", unlimited: "असीमित",
    choose_plan: "अपनी योजना चुनें",
    points_to_basic: "बेसिक प्लान के लिए अंक",
    redeem_points: "500 अंक भुनाएं",
    limit_reached: "दैनिक सीमा पूरी",
    limit_reached_ai: "आपने आज के 5 AI कोच संदेश उपयोग कर लिए हैं",
    limit_reached_rewrite: "आपने आज के 3 AI सुधार उपयोग कर लिए हैं",
    unlock_premium: "प्रीमियम अनलॉक करें",
    save: "सहेजें", cancel: "रद्द", delete: "हटाएं",
    send: "भेजें", type_message: "अपना संदेश लिखें…",
    observation: "अवलोकन", feeling: "भावना", need: "आवश्यकता", request: "अनुरोध",
    reminder_hour: "रिमाइंडर समय", reminder_off: "कोई रिमाइंडर नहीं",
    enable_notifications: "सूचनाएं सक्षम करें",
    notifications_enabled: "सूचनाएं सक्षम",
    skip: "छोड़ें",
    onboard_welcome_title: "शांत संवाद में स्वागत है",
    onboard_welcome_body: "यह ऐप केवल अहिंसक संचार सीखने के लिए नहीं है — यह वास्तविक संघर्षों को 60 सेकंड में हल करने के लिए आपका AI कोच है।",
    onboard_coach_try: "अभी AI कोच आज़माएं",
    onboard_coach_later: "बाद में, मुझे डायरी दिखाएं",
    onboard_next: "अगला",
    onboard_refine_now: "AI से सुधारें",
    onboard_copy: "संदेश कॉपी करें",
    onboard_finish: "उपयोग शुरू करें",
    error: "एक त्रुटि हुई",
    the_four_steps: "अहिंसक संचार के 4 चरण", key_points: "मुख्य बिंदु",
    mark_complete: "पूर्ण के रूप में चिह्नित करें", completed: "पूर्ण",
    next_step: "अगला चरण", continue_learning: "सीखना जारी रखें", start_learning: "सीखना शुरू करें",
    lesson: "पाठ", correct: "सही!", incorrect: "फिर से कोशिश करें",
    show_explanation: "व्याख्या दिखाएं", next_exercise: "अगला", prev_exercise: "पिछला",
    choose_context: "संदर्भ चुनें", scenario: "परिदृश्य", optional_scenario: "परिदृश्य (वैकल्पिक)",
    start_practice: "अभ्यास शुरू करें", coach_thinking: "कोच सोच रहा है…", context: "संदर्भ",
    practice_intro: "संदर्भ चुनें और कोच के साथ वास्तविक बातचीत का अभ्यास करें।",
    new_entry: "नई प्रविष्टि", notes: "टिप्पणी",
    no_entries: "अभी कोई प्रविष्टि नहीं। पहली लिखें।",
    refine_ai: "AI से सुधारें", ai_rewriting: "AI पुनर्लेखन कर रहा है…",
    ai_suggestion: "अहिंसक संचार सुझाव", use_suggestion: "सुझाव उपयोग करें", export_pdf: "PDF निर्यात करें",
    saved: "सहेजा गया", deleted: "हटाया गया",
    feelings_met: "भावनाएँ (आवश्यकताएँ पूरी)",
    feelings_unmet: "भावनाएँ (आवश्यकताएँ अधूरी)",
    needs: "सार्वभौमिक आवश्यकताएँ",
    library_intro: "अपनी भावनाओं और आवश्यकताओं की शब्दावली बढ़ाएँ।",
    premium_features: "प्रीमियम लाभ",
    premium_feat_1: "उन्नत संदर्भ अभ्यास (25+)",
    premium_feat_2: "असीमित AI कोच (मुफ्त: 5/दिन)",
    premium_feat_3: "असीमित AI डायरी सुधार (मुफ्त: 3/दिन)",
    premium_feat_4: "कोई पेवॉल या रुकावट नहीं",
    or_pay: "या कार्ड से भुगतान करें",
    processing_payment: "भुगतान संसाधित हो रहा है…", payment_success: "भुगतान सफल! प्रीमियम सक्रिय।",
    payment_pending: "भुगतान सत्यापित हो रहा है…", payment_failed: "भुगतान पूर्ण नहीं हुआ",
    premium_active: "प्रीमियम सक्रिय", points_earned: "+{n} अंक",
    onboard_step1: "अपनी स्थिति लिखें", onboard_step2: "AI से सुधारें", onboard_step3: "कॉपी करें और भेजें",
    onboard_write_below: "एक वास्तविक स्थिति लिखें (या उदाहरण उपयोग करें):",
    onboard_use_example: "उदाहरण उपयोग करें", onboard_copied: "क्लिपबोर्ड पर कॉपी हो गया",
    onboard_bullet_coach: "वास्तविक संघर्षों के लिए AI कोच",
    onboard_bullet_coach_desc: "कठिन बातचीत का अनुकरण करें और वास्तविक समय में सहानुभूतिपूर्ण मार्गदर्शन प्राप्त करें।",
    onboard_bullet_journal: "अहिंसक संचार डायरी + AI पुनर्लेखन",
    onboard_bullet_journal_desc: "अपनी भावनाएँ लिखें और AI इसे भेजने योग्य संदेश में बदल देगा।",
    onboard_coach_title: "अपने AI कोच को आज़माएँ", onboard_coach_body: "पहले, ऐप का मुख्य आकर्षण।",
    onboard_coach_pitch: "कोई भी कठिन स्थिति लिखें और AI कोच आपको वास्तविक समय में मार्गदर्शन देगा।",
    onboard_coach_bullet1: "परिवार, साथी, कार्य, स्कूल: 5 संदर्भ",
    onboard_coach_bullet2: "Claude Sonnet 4.5 द्वारा संचालित",
    onboard_coach_bullet3: "प्रति दिन 5 मुफ्त बातचीत",
    send_test_push: "परीक्षण भेजें", push_sent: "सूचना भेजी गई",
    reminders: "दैनिक अनुस्मारक", notifications_denied: "सूचनाएँ अवरुद्ध",
    locked_content: "प्रीमियम सामग्री", upgrade_to_unlock: "अनलॉक करने के लिए प्रीमियम में अपग्रेड करें",
    refer_friend: "मित्र को आमंत्रित करें",
    refer_desc: "जब वे आपके कोड से पंजीकरण करते हैं तो दोनों को {days} दिन बेसिक मुफ्त मिलते हैं।",
    your_referral_code: "आपका कोड", copy_link: "लिंक कॉपी करें", copied: "कॉपी हो गया",
    friends_referred: "आमंत्रित मित्र", days_earned_free: "अर्जित मुफ्त दिन",
    invalid_referral: "अमान्य रेफरल कोड", referral_code_optional: "रेफरल कोड (वैकल्पिक)",
    referral_applied: "🎉 कोड लागू हुआ! आपको 30 दिन बेसिक मुफ्त मिलेंगे।",
    steps_completed: "चरण पूर्ण", exercises_solved: "अभ्यास हल",
    journal_entries: "डायरी प्रविष्टियाँ", accuracy: "सटीकता",
    streak_fire: "🔥 आग पर!",
    streak_milestone_3: "लगातार 3 दिन! ऐसे ही रखो।",
    streak_milestone_7: "🔥 एक हफ्ता! प्रभावशाली।",
    streak_milestone_14: "🔥🔥 दो हफ्ते! आप आदत बना रहे हैं।",
    streak_milestone_30: "🔥🔥🔥 पूरा एक महीना! अहिंसक संचार आपका हिस्सा बन गया।",
    streak_milestone_100: "🌟 100 दिन! आप अहिंसक संचार के मास्टर हैं।",
  },
};

export const RTL_LANGS = ["ar"];

export const languages = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "de", label: "Deutsch" },
  { code: "zh", label: "简体中文" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
];

export function t(lang, key) {
  return dict[lang]?.[key] ?? dict.en[key] ?? key;
}

export function pick(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.en ?? obj.es ?? Object.values(obj)[0];
}
